import React from 'react';
import styled from 'react-emotion';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel } from 'material-ui/Stepper';

import { GradientButton } from './GradientButton';
import { scrollTo } from '../lib/scroll';
import { MOBILE_WIDTH } from '../lib/constants';

const Container = styled('div')`
  min-height: 100vh;
  margin: 0 auto;
  padding: 2em 0;
  text-align: center;
  width: 80%;
`;

const TextSection = styled('div')`
  padding-bottom: 2em;
`;

export const About = () => {
  const isMobile = window.innerWidth <= MOBILE_WIDTH;
  return (
    <Container id="about">
      <TextSection>
        <Typography type="display3" gutterBottom>
          How It Works
        </Typography>
        <Stepper orientation={isMobile ? 'vertical' : 'horizontal'} alternativeLabel={!isMobile}>
          <Step active>
            <StepLabel>Pick a Time</StepLabel>
          </Step>
          <Step active>
            <StepLabel>Confirm Your Match</StepLabel>
          </Step>
          <Step active>
            <StepLabel>Show Up!</StepLabel>
          </Step>
        </Stepper>
      </TextSection>
      <TextSection>
        <Typography type="display3" gutterBottom>
          What Is Argo?
        </Typography>
        <Typography type="body1" gutterBottom>
          We wanted a fun, easy way of meeting someone new, so we made Argo Friend Date,
          a free service that sets you up on blind friend dates with random cool people
          in Ann Arbor. Just tell us when you're available, and we'll tell you when and
          where to show up to meet someone new!
        </Typography>
        <br />
        <GradientButton
          onClick={scrollTo('download')}>
          Alright I'm In!
        </GradientButton>
      </TextSection>
    </Container>
  )
};


// WEBPACK FOOTER //
// ./src/components/About.jsx